import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidCarSideviewIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19 9.5h-.3l-1.2-3.1c-.5-1.1-1.6-1.9-2.8-1.9h-6c-1.4 0-2.7 1-2.9 2.4l-.6 2.6H5c-1.7 0-3 1.3-3 3v3.4c0 .1.1.1.1.2l.1.1.1.1c.1 0 .1.1.2.1h1.4c0 1.7 1.3 3 3 3s3-1.3 3-3h4c0 1.7 1.3 3 3 3s3-1.3 3-3h1.4c.1 0 .1-.1.2-.1l.1-.1.1-.1c0-.1.1-.1.1-.2v-3.4c.2-1.7-1.1-3-2.8-3Zm-6-3h1.6c.4 0 .8.2.9.6l.9 2.4H13v-3Zm-5.3.8c.1-.5.5-.8 1-.8H11v3H7.2l.5-2.2ZM7 17.5c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1Zm10 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1Z"/>
  </SvgIcon>
}

export default SolidCarSideviewIcon
